<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :is-form-fetched="isFetched"
    :module-enabler="moduleEnabler"
    :has-buttons="false"
  >
    <template #[`inspections.input`]>
      <v-row no-gutters>
        <v-col cols="6">
          <inspections-settings-list />
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import InspectionsSettingsList from '@/components/InspectionsSettingsList';

export default {
  name: 'InspectionsSettings',
  components: { AdminWrapper, InspectionsSettingsList },
  computed: {
    additionalModuleName: get('admin/additionalModules@INSPECTIONS_MODULE.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@inspections_module_enabled'),
    inputs() {
      return [
        {
          name: 'inspections',
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'inspections_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getLayers: call('layers/getLayers'),
    getInspections: call('inspections/getInspections'),
    async init() {
      await Promise.all([
        this.getInspections(),
        this.getLayers(),
        this.getDataSources({ with_attributes_schema: true }),
      ]);
      this.isFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFetched = true;
    }
  },
};
</script>
